import { lazy } from 'react'

const DashboardRoutes = [
  {
    path: '/dashboard',
    component: lazy(() => import('../../views/dashboard')),
    exact: true
  },
  {
    path: '/feed',
    component: lazy(() => import('../../views/feed')),
    exact: true,
    meta: {
      publicRoute: true,
      menuCollapsed: true
    }
  },
  {
    path: '/coupon/add_custom/:id',
    component: lazy(() => import('../../views/coupon/add/custom/CuponAddCustom')),
    exact: true
  },
  {
    path: '/coupons',
    component: lazy(() => import('../../views/coupons')),
    exact: true
  },
  {
    path: '/couponGenerator',
    component: lazy(() => import('../../views/couponGenerator')),
    exact: true
  },
  {
    path: '/coupon/add_custom',
    component: lazy(() => import('../../views/coupon/add/custom/CuponAddCustom')),
    exact: true
  },
  {
    component: lazy(() => import('../../views/coupon/add-new')),
    path: '/coupon/add/:sport/:url/:lid?',
    className: 'todo-application'
  },
  {
    component: lazy(() => import('../../views/coupon/CouponShortLink')),
    path: '/l/:couponId',
    meta: {
      publicRoute: true
    }
  },
  {
    component: lazy(() => import('../../views/coupon/add-new')),
    path: '/coupon/add',
    // appLayout: true,
    className: 'coupon-adding-page'
  },
  {
    component: lazy(() => import('../../views/coupon/add-new')),
    path: '/coupon/add-new',
    // appLayout: true,
    className: 'coupon-adding-page'
  },
  {
    path: '/coupon/:sport/:id',
    component: lazy(() => import('../../views/coupon/type')),
    // appLayout: true,
    className: 'todo-application'
  },
  {
    path: '/chat',
    component: lazy(() => import('../../views/chat')),
    appLayout: true,
    className: 'chat-application'
  },
  {
    component: lazy(() => import('../../views/payments')),
    path: '/payments',
    exact: true
  },
  {
    component: lazy(() => import('../../views/tipsters')),
    path: '/tipsters',
    exact: true
  },
  {
    component: lazy(() => import('../../views/tournament')),
    path: '/mistrzostwa-typerow',
    exact: true,
    meta: {
      publicRoute: true,
      menuCollapsed: true
    }
  },
  {
    component: lazy(() => import('../../views/tournament/TournamentDetailsView')),
    path: '/tournaments/:id',
    exact: true
  }
]

export default DashboardRoutes
